module.exports = __webpack_public_path__ + "assets/4dd4c6adc94adc6c19859399e043ec65.svg";